<script lang="ts" setup>
import type { ToasterProps } from "vue-sonner"
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, XIcon } from "lucide-vue-next"
import { Toaster as Sonner } from "vue-sonner"
import { cn } from "@/utils/shadcn"

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    :class="cn('toaster group', props.class)"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--success-bg': 'var(--toast-success-bg)',
      '--success-text': 'var(--toast-success-text)',
      '--success-border': 'var(--toast-success-border)',
      '--info-bg': 'var(--toast-info-bg)',
      '--info-text': 'var(--toast-info-text)',
      '--info-border': 'var(--toast-info-border)',
      '--warning-bg': 'var(--toast-warning-bg)',
      '--warning-text': 'var(--toast-warning-text)',
      '--warning-border': 'var(--toast-warning-border)',
      '--error-bg': 'var(--toast-error-bg)',
      '--error-text': 'var(--toast-error-text)',
      '--error-border': 'var(--toast-error-border)',
      '--border-radius': 'var(--radius)',
    }"
    v-bind="props"
    position="top-center"
    :toast-options="{
      classes: {
        toast: 'group-[.toaster]:pr-4 group-[.toaster]:border-l-4',
        success: 'group-[.toaster]:bg-[var(--toast-success-bg)] group-[.toaster]:border-l-[var(--toast-success-border)]',
        info: 'group-[.toaster]:bg-[var(--toast-info-bg)] group-[.toaster]:border-l-[var(--toast-info-border)]',
        warning: 'group-[.toaster]:bg-[var(--toast-warning-bg)] group-[.toaster]:border-l-[var(--toast-warning-border)]',
        error: 'group-[.toaster]:bg-[var(--toast-error-bg)] group-[.toaster]:border-l-[var(--toast-error-border)]',
      },
    }"
  >
    <template #success-icon>
      <CircleCheckIcon class="size-4 text-[var(--toast-success-text)]" />
    </template>
    <template #info-icon>
      <InfoIcon class="size-4 text-[var(--toast-info-text)]" />
    </template>
    <template #warning-icon>
      <TriangleAlertIcon class="size-4 text-[var(--toast-warning-text)]" />
    </template>
    <template #error-icon>
      <OctagonXIcon class="size-4 text-[var(--toast-error-text)]" />
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="size-4 animate-spin text-[var(--toast-loading-text)]" />
      </div>
    </template>
    <template #close-icon>
      <XIcon class="size-3" />
    </template>
  </Sonner>
</template>
